import React, { Component } from 'react'
import "./Project.scss";
import { Link } from 'react-router-dom';

export default class Project extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayDescript: false
        }
    }

    render() {
        return (
            <Link to={`/Projects/${this.props.details.title}`} className="screenshot my-5 mx-auto" onMouseEnter={() => this.setState({ displayDescript: !this.state.displayDescript })} onMouseLeave={() => this.setState({ displayDescript: !this.state.displayDescript })}>
                {this.state.displayDescript
                    ? <h3>{this.props.details.title}</h3>
                    : <div />}
                {this.state.displayDescript
                    ? <h5>{this.props.details.technology}</h5>
                    : <div />}
                <img src={this.props.details.src} alt={this.props.details.name} />
            </Link>
        )
    }
}
